var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsNumber, IsString, IsUUID } from 'class-validator';
import { PreventionCourseModuleSimpleDto } from './prevention-course-module.simple.dto.js';
export class PreventionCourseSimpleDto {
    id;
    title;
    thumbnailImage;
    price;
    shortDescription;
    longDescription;
    contactName;
    contactEmail;
    contactImg;
    preventionCourseModules;
    owned;
    paymentEnabled;
    vouchersEnabled;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PreventionCourseSimpleDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseSimpleDto.prototype, "title", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PreventionCourseSimpleDto.prototype, "thumbnailImage", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], PreventionCourseSimpleDto.prototype, "price", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseSimpleDto.prototype, "shortDescription", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseSimpleDto.prototype, "longDescription", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseSimpleDto.prototype, "contactName", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseSimpleDto.prototype, "contactEmail", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], PreventionCourseSimpleDto.prototype, "contactImg", void 0);
__decorate([
    IsArray(),
    Expose(),
    Type(() => PreventionCourseModuleSimpleDto),
    __metadata("design:type", Array)
], PreventionCourseSimpleDto.prototype, "preventionCourseModules", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PreventionCourseSimpleDto.prototype, "owned", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PreventionCourseSimpleDto.prototype, "paymentEnabled", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PreventionCourseSimpleDto.prototype, "vouchersEnabled", void 0);
//# sourceMappingURL=prevention-course.simple.dto.js.map